module.exports = __webpack_public_path__ + "img/pig10.90ffba59.png";